export const API_URL = {
  LOGIN: "/api/login",
  SIGNUP: "/api/signup",
  LIST_CHAT_USERS: "/api/users",
  ADD_USER_TO_CHAT: "/api/add-user",
};
